import express from "express"

import { getList } from "../services/recipes.js"

const router = express.Router()

router.get("/", async function (_req, res, next) {
	try {
		res.json(await getList())
	} catch (err) {
		console.error(`Error while getting recipes `, err instanceof Error ? err.message : String(err))
		next(err)
	}
})

export default router
